var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    {
      class: [
        {
          "schedule-layout": true,
          "box-layout": _vm.boxLayout,
          "rtl-layout": _vm.rtlLayout
        }
      ],
      attrs: { id: "inspire" }
    },
    [
      _c(
        "div",
        { staticClass: "app-default-layout" },
        [
          !_vm.canRender
            ? [_c("socket", { attrs: { size: "112px" } })]
            : _vm._e(),
          _vm._v(" "),
          _vm.canRender
            ? [
                _c(
                  "div",
                  { staticClass: "app-sidebar-container" },
                  [_c("NavSidebarHOC")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "app-content",
                    on: { click: _vm.onBodyClicked }
                  },
                  [
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: "router-anim",
                          "enter-active-class":
                            "animated " + _vm.selectedRouterAnimation
                        }
                      },
                      [_c("router-view")],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("renew-token", { attrs: { user: _vm.user } }),
          _vm._v(" "),
          _c("AppConfirmationDialog")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5be044b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5be044b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/schedule.vue
// module id = TDSr
// module chunks = 5